export default "__VITE_ASSET__CmeuMfwX__"